var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9528 2C12.2071 1.99989 12.4514 2.10077 12.6312 2.2806L18.0544 7.70443C19.2611 8.91038 20.0837 10.4473 20.417 12.1204C20.7503 13.7937 20.5794 15.5285 19.9268 17.1048C19.2741 18.6811 18.1688 20.0286 16.7504 20.9766C15.3319 21.9245 13.6641 22.4303 11.958 22.4303C10.252 22.4303 8.5842 21.9245 7.16572 20.9766C5.74727 20.0286 4.64194 18.6811 3.98929 17.1048C3.33665 15.5285 3.1658 13.7937 3.49905 12.1204C3.83234 10.4473 4.65429 8.91038 5.86103 7.70443L11.2751 2.28125L11.3454 2.21745C11.5159 2.07756 11.7304 2.0001 11.9528 2ZM7.21585 9.06055C6.2774 9.99847 5.63782 11.1936 5.37861 12.4948C5.11941 13.7962 5.25251 15.1457 5.76012 16.3717C6.26774 17.5977 7.12762 18.6455 8.23083 19.3828C9.33408 20.1201 10.6311 20.5137 11.958 20.5137C13.285 20.5137 14.582 20.1201 15.6853 19.3828C16.7885 18.6455 17.6483 17.5977 18.156 16.3717C18.6636 15.1457 18.7967 13.7962 18.5375 12.4948C18.2783 11.1936 17.6387 9.99847 16.7002 9.06055L11.9535 4.3138L7.21585 9.06055Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrop);
export default __webpack_public_path__ + "static/media/water-drop.293d9744b33621fa6d1daa11c3108101.svg";
export { ForwardRef as ReactComponent };